import { logUsage } from 'owa-analytics';
import ItemId from 'owa-service/lib/contract/ItemId';
import getAttachMenuData from './getAttachMenuData';

export default function logAttachMenuDataOnClose(referenceItemId: ItemId) {
    const menuData = getAttachMenuData(referenceItemId);

    // Log data now.
    // This datapoint is used in OWA intelligence scorecard.
    // Make sure any change won't break the scorecard
    logUsage('AttachButtonMenuClosed', [true /* isMail */, ...menuData]);
}
